module.exports = __webpack_public_path__ + "img/gift-box.5a2f4039.svg";